var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleeve2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 114,
    viewBox: "0 0 36 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2003_7427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8321 111.501C23.8321 111.501 22.3561 113.83 17.8611 109.904C17.8611 109.904 15.2362 106.877 13.2067 106.502C11.1772 106.128 10.7411 102.784 10.7411 102.784C8.65296 95.0657 3.57089 88.5114 3.73022 84.311",
    stroke: "black",
    strokeWidth: 0.154226,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7329 102.784C10.7329 102.784 8.43505 101.403 7.3616 97.4192C7.78092 96.0967 0.0739392 85.5916 1.09706 81.3329C1.09706 81.3329 1.14738 81.1749 2.64852 77.9893",
    stroke: "black",
    strokeWidth: 0.154226,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8664 70.8032C32.0761 71.8013 32.2606 72.9824 32.2857 74.1136C33.8959 78.9628 31.7155 85.7583 32.2857 89.6177C32.2857 89.6177 32.8979 93.0861 32.3947 96.0223C32.3947 96.0223 34.3907 108.307 27.4385 103.708C23.7904 100.772 24.1846 92.0215 23.933 84.311L23.1195 83.4626C23.1195 83.4626 22.4738 83.8453 21.828 83.9534C21.1907 84.0615 22.1132 85.201 20.6204 86.5235C20.6204 86.5235 21.7945 87.8128 20.9056 89.8672C20.9056 89.8672 22.3312 92.5954 20.6204 92.9447C22.4319 93.4022 23.0441 102.784 25.4509 104.115C25.4509 104.115 26.7676 105.438 26.7508 107.085C26.7508 107.085 30.9104 109.796 30.382 111.867C30.382 111.867 30.751 117.49 20.2598 108.782C19.4547 108.199 16.4105 105.546 15.7145 103.267C15.7145 103.267 11.5884 91.6389 10.1963 89.7757",
    stroke: "black",
    strokeWidth: 0.154226,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0969 81.3332C-0.530036 78.5884 1.82651 74.7124 2.57288 67.4927",
    stroke: "black",
    strokeWidth: 0.154226,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1788 0.26123C36.4619 9.46052 33.1074 40.0028 32.7552 49.643C34.2899 51.8305 32.1933 70.9444 31.9333 70.803H31.8663C16.4523 71.7429 6.57327 68.9648 2.57302 67.4926C1.21444 67.0019 0.535156 66.6608 0.535156 66.6608C2.59818 56.7213 1.13058 47.314 2.14532 46.2494C3.72194 33.1075 2.80783 9.4023 2.95879 0.26123",
    fill: "#737474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1788 0.26123C36.4619 9.46052 33.1074 40.0028 32.7552 49.643C34.2899 51.8305 32.1933 70.9444 31.9333 70.803H31.8663C16.4523 71.7429 6.57327 68.9648 2.57302 67.4926C1.21444 67.0019 0.535156 66.6608 0.535156 66.6608C2.59818 56.7213 1.13058 47.314 2.14532 46.2494C3.72194 33.1075 2.80783 9.4023 2.95879 0.26123",
    stroke: "#231F20",
    strokeWidth: 0.154226,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95898 46.5986C2.95898 46.5986 14.163 50.5661 31.8664 49.6429",
    stroke: "black",
    strokeWidth: 0.0925358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9689 67.2262C30.9689 67.4175 30.9605 67.5922 30.9353 67.7669C30.8347 68.6236 30.4825 69.2474 30.0716 69.2474C29.5852 69.2474 29.1826 68.3408 29.1826 67.2262C29.1826 66.3778 29.4174 65.6542 29.7445 65.3631C29.8451 65.2633 29.9542 65.2134 30.0716 65.2134C30.5664 65.2134 30.9689 66.1117 30.9689 67.2262Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2003_7427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.1636,
    height: 113.511,
    fill: "white",
    transform: "translate(0.417969 0.244629)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleeve2);
export default __webpack_public_path__ + "static/media/sleeve-2.b23f61b3e9722c927021e8644f089dba.svg";
export { ForwardRef as ReactComponent };